/* One mobile purchase bar, synchronized with the native product form. */
(() => {
  function setup() {
    const bar = document.querySelector('[data-ev-mobile-buybar]');
    const core = document.querySelector('product-info[id^="MainProduct"]');
    const original = core?.querySelector('.product-form__submit');
    if (!bar || !original || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const button = bar.querySelector('[data-ev-mobile-buy]');
    const price = bar.querySelector('[data-ev-bar-price]');
    const variant = bar.querySelector('[data-ev-bar-variant]');
    const english = document.documentElement.lang.startsWith('en');
    let raf = 0;
    function sync() {
      raf = 0;
      const busy = original.classList.contains('loading');
      const unavailable = original.disabled || original.getAttribute('aria-disabled') === 'true';
      const overlay = document.querySelector('cart-drawer.active, dialog[open], product-modal[open], header-drawer details[open], details-modal details[open], [data-ev-welcome-popup]:not([hidden])');
      const viewport = window.visualViewport;
      const editing = document.activeElement?.matches('input, textarea, [contenteditable="true"]');
      const keyboard = editing && viewport && window.innerHeight - viewport.height > 150;
      const visible = window.innerWidth <= 749 && original.getBoundingClientRect().bottom < 0 && !overlay && !keyboard;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      bar.inert = !visible;
      const currentPrice = core.querySelector('.price--on-sale .price-item--sale') || core.querySelector('.price__regular .price-item');
      if (currentPrice && price.textContent !== currentPrice.textContent.trim()) price.textContent = currentPrice.textContent.trim();
      const options = [...core.querySelectorAll('variant-selects [data-selected-value]')].map(el => el.textContent.trim()).filter(Boolean);
      const variantLabel = options.join(' / ') || (english ? 'Your selected product' : 'Tu producto seleccionado');
      if (variant.textContent !== variantLabel) variant.textContent = variantLabel;
      const nativeLabel = original.querySelector('span')?.textContent.trim();
      button.disabled = busy || unavailable;
      button.dataset.mode = unavailable ? 'unavailable' : 'add';
      const buttonLabel = busy
        ? (english ? 'Adding…' : 'Agregando…')
        : unavailable
          ? (nativeLabel || (english ? 'Unavailable' : 'No disponible'))
          : (english ? 'Add to cart' : 'Agregar al carrito');
      if (button.textContent !== buttonLabel) button.textContent = buttonLabel;
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(sync); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    new MutationObserver(schedule).observe(core, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    const overlayObserver = new MutationObserver(schedule);
    document.querySelectorAll('[data-ev-welcome-popup], product-modal, dialog, header-drawer details, details-modal details').forEach(el => overlayObserver.observe(el, { attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden'] }));
    button.addEventListener('click', () => {
      if (button.disabled || button.dataset.mode === 'unavailable') return;
      original.click();
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
